import { Record as ImmutableRecord } from 'immutable';

export type SocketState =
  | 'CONNECTING'
  | 'OPEN'
  | 'ERROR'
  | 'CLOSING'
  | 'CLOSED'
  | 'AUTHENTICATED'
  | 'RECONNECTING'
  | 'UNKNOWN';

export const SocketStates = Object.freeze({
  CONNECTING: 'CONNECTING',
  OPEN: 'OPEN',
  ERROR: 'ERROR',
  CLOSING: 'CLOSING',
  CLOSED: 'CLOSED',
  AUTHENTICATED: 'AUTHENTICATED',
  RECONNECTING: 'RECONNECTING',
} satisfies { [K in SocketState]?: K });

export type BumpMessageData = {
  resourceType?: string;
  resources?: unknown[];
  jobType?: string;
};

export type BumpMessage = {
  type?: string;
  eventType?: string;
  data?: BumpMessageData;
};

export const BUMP_REDUCER_KEY = 'bump';

export type BumpStoreProps = {
  socketState: SocketState;
};

export const mkBumpStore = ImmutableRecord<BumpStoreProps>({
  socketState: SocketStates.CLOSED,
});
export type BumpStore = ReturnType<typeof mkBumpStore>;

export const CLOSE_BUMP_DISABLED = 4000;
export const CLOSE_BUMP_NEEDS_RECONNECTION = 4001;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [BUMP_REDUCER_KEY]: BumpStore;
  }
}
